import { render, staticRenderFns } from "./rawMaterial.vue?vue&type=template&id=e9510754&"
import script from "./rawMaterial.vue?vue&type=script&lang=js&"
export * from "./rawMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports